import Date from "./date";
import Link from "next/link";
import Image from "next/image";
import { urlForImage } from "@/lib/sanity";
import { getImageDimensions } from "@sanity/asset-utils";
import classNames from "classnames";

export default function PostPreview({
  title,
  image: source,
  date,
  excerpt,
  slug,
}) {
  if (!source) {
    return null;
  }
  const { width, height } = getImageDimensions(source);
  const image = (
    <Image
      layout="responsive"
      width={500}
      height={250}
      alt={`Cover Image for ${title}`}
      src={urlForImage(source).width(width).height(height).url()}
      className="bg-light-purple object-cover"
    />
  );

  return (
    <Link href={`/${slug}`}>
      <div
        className={classNames(
          "group grid grid-rows-[160px_240px] border border-lighter-purple",
          "rounded-2xl overflow-hidden bg-white hover:cursor-pointer"
        )}
      >
        {image}
        <div className="flex flex-col justify-between">
          <div className="p-4 relative">
            <div className="text-xs mb-2">
              <Date dateString={date} />
            </div>
            <div className="line-clamp-6">
              <h3 className="text-base mb-2 font-medium tracking-tight leading-snug group-hover:text-dark-purple">
                {title}
              </h3>
              <p className="text-vsm">{excerpt}</p>
            </div>
          </div>
          <p
            className={classNames(
              "py-2 text-center font-medium",
              "text-vsm md:text-xs",
              "text-dark-purple group-hover:text-light-purple"
            )}
          >
            READ MORE
          </p>
        </div>
      </div>
    </Link>
  );
}
